const Round = props => (
  <svg {...props} width="17px" height="16px" viewBox="0 0 17 16">
    <g id="FPCBuilder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-611.000000, -95.000000)">
      <circle id="Oval-Copy-2" stroke="#313F4C" strokeWidth="1.5" cx="619.595792" cy="103" r="7"></circle>
    </g>
  </svg>
);

export default Round;
